import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Card, CardBody, Col, FormGroup, Label, Row, Table } from "reactstrap";
import {
  GET_RP_BALANCE,
  GET_RP_BALANCE_EAST,
  GET_RP_BALANCE_TOTAL,
  GET_RP_BALANCE_WEST,
  GET_RP_OVERUSE_CODE,
  GET_RP_OVERUSE_CODE_DATA,
} from "../../../../helpers/url_api_constant";
import React, { useEffect, useState } from "react";

import ChartOnshore from "./ChartOnshore";
import OveruseByContact from "./OveruseByContact";
import PropTypes from "prop-types";
import Select from "react-select";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SectionCapacityOveruseByContact(props) {
  // console.log(props);
  const dispatch = useDispatch();

  const searchDate = { SELECT_DATE: props.date };

  // DropDown Search
  const [dropDownShipper, setDropDownShipper] = useState({
    label: "",
    value: "", OVERUSECODE_PID: ""
  });
  const [listShipper, setListShipper] = useState([]);
  // DropDown Search

  // Handle Set Value DropDown Search //
  const handleSelectDropDownShipper = selected => {
    setDropDownShipper(selected);
  };
  // Handle Set Value DropDown Search //

  const [shippers, setShippers] = useState([]);
  const [contactCount, setContactCount] = useState(0)
  const [overuseData, setOveruseData] = useState([]);


  const [minMaxTotalList, setMinMaxTotalList] = useState([]);
  const [minMaxEastList, setMinMaxEastList] = useState([]);
  const [minMaxWestList, setMinMaxWestList] = useState([]);
  const [balancingOnshoreEast, setBalancingOnshoreEast] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
  });
  const [balancingOnshoreWest, setBalancingOnshoreWest] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
  });
  const [balancingOnshoreTotal, setBalancingOnshoreTotal] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
  });
  const [balancingGraphData, setBalancingGraphData] = useState([]);

  useEffect(() => {
    setListShipper(
      shippers.map(item => ({ label: item.SHIPPER_NAME, value: item.PID, OVERUSECODE_PID: item.OVERUSECODE_PID }))
    );
  }, [shippers]);

  useEffect(() => {
    if (listShipper.length > 0) {
      setDropDownShipper(listShipper[0]);
    } else {
      setDropDownShipper({ label: "", value: "", OVERUSECODE_PID: "" });
    }
  }, [listShipper]);
  useEffect(() => {
    getShipperList();
  }, [props.summaryReportPid]);
  useEffect(() => {
    fetchData();
  }, [dropDownShipper]);
  useEffect(() => { }, [props.date]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const getShipperList = async () => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    dispatch(loadingAction.showLoading());
    try {
      let [res1] = await Promise.all([
        post(GET_RP_OVERUSE_CODE, {
          SUMMARYREPORT_PID:
            props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        }),
      ]);
      let data = res1.data.RPOversureShipperList;

      let shipperList = data.map((item, index) => ({
        OVERUSECODE_PID: item.PID,
        SHIPPER_NAME: item.OVERUSECODE_SHIPPER,
        PID: item.OVERUSECODE_PID,
        PRIORITY_FLAG: item.OVERUSECODE_ORDER,
      }));
      shipperList = [
        ...new Map(shipperList.map(item => [item["PID"], item])).values(),
      ];

      setShippers(shipperList.sort(compare));
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const fetchData = async () => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    function compareArea(a, b) {
      if (a.OVERUSE_AREA < b.OVERUSE_AREA) {
        return -1;
      }
      if (a.OVERUSE_AREA > b.OVERUSE_AREA) {
        return 1;
      }
      return 0;
    }
    dispatch(loadingAction.showLoading());
    try {
      let [res1, res2, res3, minMaxTotal, minMaxEast, minMaxWest] =
        await Promise.all([
          post(GET_RP_OVERUSE_CODE_DATA, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
            OVERUSECODE_PID: dropDownShipper.OVERUSECODE_PID
          }),
          post(GET_RP_BALANCE, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
            BALANCECOLUMN_PID: dropDownShipper.value,
          }),
          post(GET_RP_BALANCE, {
            REPORT_DATE: moment(props.date).format("YYYY-MM-DD"),
            BALANCECOLUMN_PID: dropDownShipper.value,
          }),
          post(GET_RP_BALANCE_TOTAL, {}),
          post(GET_RP_BALANCE_EAST, {}),
          post(GET_RP_BALANCE_WEST, {}),
        ]);
      setMinMaxTotalList(
        minMaxTotal.data.rpBalancingTotalList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );
      setMinMaxWestList(
        minMaxWest.data.rpBalancingWestList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );
      setMinMaxEastList(
        minMaxEast.data.rpBalancingEastList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );
      let data = res1.data.rpOveruseCodeDataList.map(row=>({...row,
    
        OVERUSE_ACTUAL: Math.round(row.OVERUSE_ACTUAL),
        OVERUSE_BOOKING: Math.round(row.OVERUSE_BOOKING),
        OVERUSE:row.OVERUSE_ACTUAL> row.OVERUSE_BOOKING? Math.round(row.OVERUSE_ACTUAL )-Math.round(row.OVERUSE_BOOKING ):0,
      }))
      let balancing = res2.data.rpBalancingList;
      let graphData = res3.data?.rpBalancingList;
      if (graphData) {
        setBalancingGraphData(graphData);
      } else {
        setBalancingGraphData([]);
      }

      let balancingEast = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "east"
      );
      let balancingWest = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "west"
      );
      let balancingTotal = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "total"
      );
      if (balancingEast) {
        setBalancingOnshoreEast(balancingEast);
      } else {
        setBalancingOnshoreEast({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
        });
      }
      if (balancingWest) {
        setBalancingOnshoreWest(balancingWest);
      } else {
        setBalancingOnshoreWest({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
        });
      }
      if (balancingTotal) {
        setBalancingOnshoreTotal(balancingTotal);
      } else {
        setBalancingOnshoreTotal({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
        });
      }


      let contactList = [...new Set(data.map(item => item.OVERUSE_CONTACTCODE.trim()))].sort();
      let entry = data.filter(item => item.OVERUSE_POINT.toLowerCase() == 'entry').sort(compare)
      let exit = data.filter(item => item.OVERUSE_POINT.toLowerCase() == 'exit').sort(compare)

      let entryData = entry.sort(compare).reduce((r, a, index) => {
        let prevData = r.find(row => row.OVERUSE_AREA == a.OVERUSE_AREA)
        if (prevData != undefined) {
          r.map(row => {
            if (row.OVERUSE_AREA == prevData.OVERUSE_AREA) {
              row.data = [...row.data, a]
            }
            return row
          })
        } else {
          r.push({ OVERUSE_AREA: a.OVERUSE_AREA, data: [a], PRIORITY_FLAG: a.PRIORITY_FLAG })
        }

        return r;
      }, []).sort(compareArea)
      let tempEntryTotal = entry.sort(compare).reduce((r, a) => {

        r[a.OVERUSE_CONTACTCODE.trim()] = [...r[a.OVERUSE_CONTACTCODE.trim()] || [], a];
        return r;
      }, {})
      let entryTotal = []
      Object.keys(tempEntryTotal).map(key => {
        let temp = tempEntryTotal[key].reduce((total, row) => {

          total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING
          total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL
          total.OVERUSE = total.OVERUSE + row.OVERUSE
          total.PRIORITY_FLAG = tempEntryTotal[key][0].OVERUSE_CONTACTCODE.trim()
          return total
        }, { OVERUSE_BOOKING: 0, OVERUSE_ACTUAL: 0, OVERUSE: 0, PRIORITY_FLAG: 0 })
        entryTotal.push(temp)
      })
      let exitData = exit.sort(compare).reduce((r, a, index) => {
        let prevData = r.find(row => row.OVERUSE_AREA == a.OVERUSE_AREA)
        if (prevData != undefined) {
          r.map(row => {
            if (row.OVERUSE_AREA == prevData.OVERUSE_AREA) {
              row.data = [...row.data, a]
            }
            return row
          })
        } else {
          r.push({ OVERUSE_AREA: a.OVERUSE_AREA, data: [a], PRIORITY_FLAG: a.PRIORITY_FLAG })
        }

        return r;
      }, []).sort(compareArea)
      let tempExitTotal = exit.sort(compare).reduce((r, a) => {
        r[a.OVERUSE_CONTACTCODE.trim()] = [...r[a.OVERUSE_CONTACTCODE.trim()] || [], a];
        return r;
      }, {})
      let exitTotal = []
      Object.keys(tempExitTotal).map(key => {
        let temp = tempExitTotal[key].reduce((total, row) => {
          total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING
          total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL
          total.OVERUSE = total.OVERUSE + row.OVERUSE
          total.PRIORITY_FLAG = tempExitTotal[key][0].OVERUSE_CONTACTCODE.trim()
          return total
        }, { OVERUSE_BOOKING: 0, OVERUSE_ACTUAL: 0, OVERUSE: 0, PRIORITY_FLAG: 0 })
        exitTotal.push(temp)
      })
      let contactCountList = data.map((item) => contactList.length)

      let contactCountMax = 0
      if (contactCountList.length) contactCountMax = Math.max(...contactCountList)
      setContactCount(contactCountMax)
      setOveruseData([{ SHIPPER_NAME: dropDownShipper.label, contacts: contactList, entry: entryData, entryTotal: entryTotal, exit: exitData, exitTotal: exitTotal }])

    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  return (

    <Row>

      <Row className="mt-0">
        <Col sm="12">
          <h5
            className="mb-0 sm-0 font-size-18"
            style={{ color: "#FFFFFF" }}
          >
            Capacity Overuse by Contact
          </h5>
        </Col>
      </Row>

      <Row className="mt-2">
        <hr />
      </Row>

      <div className="d-flex dashboard-content-body">
        <div className="d-flex flex-column" style={{ flex: 1.5 }}>
          {/* <div className="d-flex" style={{ flex: 1.5, margin: 5, position: "relative" }}> */}
          <FormGroup className="row">
            <Col sm={3}>
              <h5 className="mb-0 mt-3" style={{ color: "#FFFFFF" }}>Unit : BBTUU</h5>
            </Col>
            <Label className="col-sm-5 col-form-label d-flex align-items-center justify-content-end">
              Shipper
            </Label>
            <Col sm={4}>
              <Select
                placeholder="No publlic data"
                isClearable={false}
                value={dropDownShipper}
                onChange={handleSelectDropDownShipper}
                options={listShipper}
                classNamePrefix="select2-selection"
              />
            </Col>
          </FormGroup>
          
          <OveruseByContact overuseData={overuseData} contactCount={contactCount} shipper={dropDownShipper} />
          {/* </div> */}
        </div>






        {/* <div style={{ width: "100%" }}> */}
        {/* <Row>
          <OveruseByContact overuseData={overuseData} contactCount={contactCount} shipper={dropDownShipper} />
        </Row> */}
        {/* </div> */}
      </div>



      {/* <div style={{ width: '50%' }} className="mt-0 ms-2">
              <FormGroup className="row">
                <Col sm={4}>
                  <h5 style={{ color: "#FFFFFF" }}>Capacity Overuse</h5>
                </Col>
                <Label className="col-sm-2 col-form-label d-flex align-items-center justify-content-end">
                  Shipper
                </Label>
                <Col sm={6}>
                  <Select
                    placeholder="No publlic data"
                    isClearable={false}
                    value={dropDownShipper}
                    onChange={handleSelectDropDownShipper}
                    options={listShipper}
                    classNamePrefix="select2-selection"
                  />
                </Col>
              </FormGroup>
              <div style={{ width: "100%" }}>
                <OveruseByShipper
                  shipper={dropDownShipper}
                  overuseDataEntry={overuseDataEntry}
                  overuseDataExit={overuseDataExit}
                  total={total}
                />
              </div>
            </div> */}





      {/* <Row>
        <h5 className="col-sm-2 mb-0 mt-3">Unit : BBTUU</h5>
        <Label className="col-sm-6 col-form-label d-flex align-items-center justify-content-end">
          Shipper
        </Label>
        <Col sm={4}>
          <Select
            placeholder="No publlic data"
            isClearable={false}
            value={dropDownShipper}
            onChange={handleSelectDropDownShipper}
            options={listShipper}
            classNamePrefix="select2-selection"
          />
        </Col>
      </Row>

      <OveruseByContact overuseData={overuseData} contactCount={contactCount} shipper={dropDownShipper} /> */}

    </Row>
  );
}

SectionCapacityOveruseByContact.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default SectionCapacityOveruseByContact;
